import React from 'react';
import './ratechangenotification.scss';
import { formatDate } from '../../../utils/helpers';

/** @import { RateChangeNotificationProps } from "./RateChangeNotificationTypes" */

class RateChangeNotificationDetails extends React.Component {

    constructor(/** @type {RateChangeNotificationProps} */ props) {
        super(props);
    }

    render() {
        const { aerRate, rate, effectiveDate, isRateNotificationVisible } = this.props;
        return (
            <tr className={isRateNotificationVisible ? "notification__tablerow" : "notification__tablerowcollapsed"}>
                <td className="notification__cellcontent">
                    <div>{aerRate.toFixed(2)}% AER*</div>
                    <div>{rate.toFixed(2)}% gross p.a.</div>
                </td>
                <td className="notification__cellcontent">
                    {
                        //@ts-expect-error - is this a valid option?
                        formatDate(new Date(effectiveDate), "dd/MM/Y - HH:mm")
                    }
                </td>
            </tr>
        );
    }
}

export default RateChangeNotificationDetails;